module.exports = __webpack_public_path__ + "0e9654bdd39b625b67e6884037dc34f4.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/cancel-medium-light.svg
// module id = 1430
// module chunks = 1 2 4 5 6 7 9 10 13 15 24 25 28 31 32 35 38 39 45 80